import React from 'react';
import { InputField } from 'components/form';
import { useFormContext } from 'react-hook-form';

import { DealSheetFormValues } from './types';

export const CommonSection = () => {
  const { control } = useFormContext<DealSheetFormValues>();

  return (
    <>
      <InputField
        name="name"
        label="Rule Name"
        control={control}
        inputProps={{ variant: 'outlined', required: true }}
      />

      <InputField
        label="Description"
        control={control}
        name="description"
        inputProps={{ variant: 'outlined', multiline: true, minRows: 5 }}
      />
    </>
  );
};
